import { useState } from "react";
import { toast } from "sonner";

import { subscribeNewsletter } from "@/services/newsletterService";
import { getErrorMessage } from "@/services/apiClient";


const Newsletter_2 = () => {

  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const res = await subscribeNewsletter(email.trim());
      toast.success(res.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (

    <>

      <div className="section-title text-center">

        <h2 className="title">
          Want new courses <br /> the moment they launch?
        </h2>

        <form onSubmit={handleSubmit} className="newsletter-form-1 mt--50 radius-round">
          <input
            className="rbt-border"
            type="email"
            placeholder="Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="rbt-btn btn-md btn-gradient hover-icon-reverse radius-round" disabled={submitting}>
            <span className="icon-reverse-wrapper">
              <span className="btn-text">{submitting ? "Subscribing…" : "Subscribe"}</span>
              <span className="btn-icon"> <i className="feather-arrow-right"></i> </span>
              <span className="btn-icon"> <i className="feather-arrow-right"></i> </span>
            </span>
          </button>
        </form>

      </div>

    </>

  );

};




export default Newsletter_2;
